import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Bei jedem Seitenwechsel (Route-Wechsel) immer oben starten.
// Hat die URL einen Anker (#id), dort hin scrollen statt nach oben.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);
  return null;
}
